module.exports = __webpack_public_path__ + "static/img/open-title-1.bf1dd926.png";